import React, { createRef } from "react";
import i18n from "i18next";
import Calendar from "react-calendar";
import DateFnsUtils from "@date-io/date-fns";
import jaLocale from "date-fns/locale/ja";
import PropTypes from "prop-types";
import "react-calendar/dist/Calendar.css";

import "./react-calendar-override.scss";
import "./style.scss";

class DateInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldRenderCalendar: false,
      calendarContainerStyle: this.calcCalendarStyles(),
    };

    this.dateUtils = new DateFnsUtils({ locale: jaLocale });
    this.windowHeight =
      document.documentElement.clientHeight || document.body.clientHeight;
    this.dateInputRef = createRef();
    this.calendarAnchorOrigin = {
      horizontal: "center",
      vertical: "bottom",
      horizontalAlignmentOrigin: "center",
    };
    this.calendarRect = {
      width: 310,
      height: 278,
      leftOffset: 0,
      topOffset: 4,
    };
  }

  calcCalendarStyles = (anchorElemRect) => {
    if (!anchorElemRect) return {};
    let calendarLeft = 0;
    let calendarTop = 0;
    const { left, top, bottom, right } = anchorElemRect;
    const horizontalOrigin = this.calendarAnchorOrigin.horizontal;
    const verticalOrigin = this.calendarAnchorOrigin.vertical;
    const horizontalAlignmentOrigin = this.calendarAnchorOrigin
      .horizontalAlignmentOrigin;
    if (horizontalOrigin === "left") {
      if (horizontalAlignmentOrigin === "left") {
        calendarLeft = left;
      } else if (horizontalAlignmentOrigin === "right") {
        calendarLeft = left - this.calendarRect.width;
      } else {
        calendarLeft = left - Math.round(this.calendarRect.width / 2);
      }
    } else if (horizontalOrigin === "center") {
      if (horizontalAlignmentOrigin === "left") {
        calendarLeft = Math.round(right - (right - left) / 2);
      } else if (horizontalAlignmentOrigin === "right") {
        calendarLeft = Math.round(
          right - (right - left) / 2 - this.calendarRect.width
        );
      } else {
        calendarLeft = Math.round(
          right - (right - left) / 2 - this.calendarRect.width / 2
        );
      }
    } else if (horizontalOrigin === "right") {
      if (horizontalAlignmentOrigin === "left") {
        calendarLeft = right;
      } else if (horizontalAlignmentOrigin === "right") {
        calendarLeft = right - this.calendarRect.width;
      } else {
        calendarLeft = Math.round(right - this.calendarRect.width / 2);
      }
    }
    if (verticalOrigin === "top") {
      calendarTop = top;
    } else if (verticalOrigin === "center") {
      calendarTop = Math.round(bottom - (bottom - top) / 2);
    } else {
      calendarTop = bottom;
    }
    calendarLeft += this.calendarRect.leftOffset;
    calendarTop += this.calendarRect.topOffset;

    return {
      left: calendarLeft,
      top: calendarTop,
      transform: "all",
      opacity: 1,
    };
  };

  onDateInputClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const bottom = this.windowHeight - rect.bottom;
    this.calendarRect = {
      ...this.calendarRect,
      topOffset: Math.min(bottom - this.calendarRect.height - 10, 4),
    };
    this.setState({
      shouldRenderCalendar: true,
      calendarContainerStyle: this.calcCalendarStyles(rect),
    });
    this.dateInputRef.current.blur();
  };

  hideCalendar = () => {
    this.setState({
      shouldRenderCalendar: false,
    });
  };

  onCalendarChange = (date) => {
    this.setState({
      shouldRenderCalendar: false,
    });
    const { onChange } = this.props;
    onChange && onChange(date);
  };

  render() {
    const {
      placeholder,
      className,
      value,
      disabled,
      minDate,
      maxDate,
    } = this.props;
    const { shouldRenderCalendar, calendarContainerStyle } = this.state;

    return (
      <div className={`custom-date-input ${className || ""}`}>
        <input
          ref={this.dateInputRef}
          className="custom-date-input-field"
          placeholder={placeholder || i18n.t("TCMS01012_datePlaceholder")}
          value={value ? this.dateUtils.format(value, "yyyy年MM月dd日") : ""}
          onClick={this.onDateInputClick}
          disabled={disabled}
        />
        {shouldRenderCalendar && (
          <div className="calendar-modal">
            <div className="calendar-backdrop" onClick={this.hideCalendar} />
            <div className="calendar-container" style={calendarContainerStyle}>
              <Calendar
                className="calendar-main"
                prevLabel={<span />}
                prev2Label={<span />}
                nextLabel={<span />}
                next2Label={<span />}
                minDate={minDate}
                maxDate={maxDate}
                value={value || new Date()}
                locale="ja"
                calendarType="US"
                minDetail="decade"
                formatMonthYear={(_, date) => {
                  return `${date.getFullYear()}年 ${date.getMonth() + 1}月`;
                }}
                formatDay={(_, date) => {
                  return `${date.getDate()}`;
                }}
                onChange={this.onCalendarChange}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

DateInput.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  minDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  maxDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default DateInput;
